/* unplugin-vue-components disabled */import script from "./QuickImportModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./QuickImportModal.vue?vue&type=script&lang=ts&setup=true"

import "./QuickImportModal.vue?vue&type=style&index=0&id=6ba395fd&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ba395fd"]])

export default __exports__